import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';

const FaqQuestion = ({ question, answer, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [height, setHeight] = useState('0px');
  const contentRef = useRef(null);

  useEffect(() => {
    setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px');
  }, [isOpen]);

  return (
    <div className="flex items-center border-b-1 border-t-1 border-gray-200 cursor-pointer py-[16px]" onClick={() => setIsOpen(!isOpen)}>
      <div className="flex justify-between flex-col w-full text-left px-[16px]">
        <span className="text-[18px] leading-[20px] font-[400]">{question}</span>
        <p
          ref={contentRef}
          style={{ height }}
          className={classNames(
            `max-w-[950px] text-[16px] font-[300] leading-[20px] overflow-hidden transition-height duration-300 ease-in-out`,
            isOpen && 'mt-[16px]'
          )}
        >
          {answer}
        </p>
      </div>
      <img src={`/images/seo/icons/${isOpen ? 'minus-faq.svg' : 'plus-faq.svg'}`} alt="faq" />
    </div>
  );
};

export default FaqQuestion;
